import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { REPORTS_ROOT_ROUTE } from '../../routes';
import { XUXDrawerSidebarService } from '@xenial-ux/services';
import { ReportsService } from '@shared/services';
import { select_sidebar_item } from '@rpt-ngrx/actions/ui.action';
import { Store } from '@ngrx/store';
import { selectReportsHistory } from '@rpt-ngrx/selectors/reports.selector';
import { Router } from '@angular/router';
import { remove_report, remove_reports_from_history } from '@rpt-ngrx/actions/reports.action';
import { ReportNavigatorService } from '@containers/reports/report/services/report-navigator.service';

@Component({
  selector: 'xux-breadcrumb-navbar',
  templateUrl: './xux-breadcrumb-navbar.component.html',
  styleUrls: ['./xux-breadcrumb-navbar.component.scss'],
})
export class XUXBreadcrumbNavbarComponent implements OnInit {

  @Input()
  public isIframeMode$: Observable<any>;

  @Input()
  public appName: string;

  public breadcrumbs: Array<{title: string, isDetailView?: boolean, route: string, reportLink: boolean}> = [];

  constructor(
    private reportNavigator: ReportNavigatorService,
    private drawerSidebarService: XUXDrawerSidebarService,
    private reportService: ReportsService,
    private store: Store,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.store.select(selectReportsHistory).subscribe((history) => {
      this.breadcrumbs = history;
    })
  }

  public handleClick(breadcrumb: Breadcrumb, index: number): void {
    if (this.router.url === breadcrumb.route) {
      this.refreshReport();
    }

    if (index !== this.breadcrumbs.length - 1) {
      this.store.dispatch(remove_reports_from_history({index}));
    }
  }

  protected refreshReport() {
    this.reportService.reloadReport();
  }

  public backToReports() {
    this.reportNavigator.resetMainFilters();
    this.reportNavigator.unloadReport();
    this.router.navigate(['custom-reports']);
  }

  public toggleSlide(event: KeyboardEvent) {
    this.drawerSidebarService.toggle();
  }
}

interface Breadcrumb {
  title: string,
  route: string,
  reportLink: boolean
}
